import * as d3 from 'd3'
export default {
  methods: {

    gmx_Dropdown(selection, data_, props) {

      let chartMenu = selection
      .append('g')
      .attr('id', `DROPDOWN_${props.id}`)
      .attr('transform', `translate(${props.x}, ${props.y-1.5})`)
      .attr('font-family','roboto')
      .attr('visibility', props.type=='hidden' ? 'hidden' : 'display')

      chartMenu
      .append('text')
      .attr('id', `LABEL_${props.id}`)
      .attr('x', 0).attr('y', 0)
      .attr('fill', '#757575') .attr('font-size', 10).attr('font-style', 'italic')
      .text(props.label)

      let dropdown = chartMenu
      .append('g')
      .attr('transform', `translate(${0}, ${5})`)

      dropdown
      .append('rect')
      .attr('id', `DROP_BOX_${props.id}`)
      .attr('width', props.boxWidth).attr('height', 22)
      .attr('fill', '#fcfcfc').attr('stroke','#757575').attr('stroke-width', 1).attr('stroke-opacity', .3)

      dropdown
      .append('path')
      .attr('id', `ARROW_${props.id}`)
      .attr('transform', `translate(${props.boxWidth - 12}, 10)`).attr('fill', '#bcbcbc')
      .attr('d',`M3.9,4.6C4,4.6,7.9,1,7.9,1l-1-1l-3,2.9L1,0L0,1C0,1,3.9,4.6,3.9,4.6z`)

      dropdown
      .append('text')
      .attr('id', `FORM_${props.id}`)
      .attr('x', props.icon ? 25 : 5).attr('y', 11 + 12*0.36)
      .attr('fill', '#333') .attr('font-size', 12).attr('font-style', 'italic')
      .text(props.value ? props.value : data_[0])

      if(props.icon) {
        dropdown
        .append('image')
        .attr('id', `ICON_${props.icon}`)
        .attr('xlink:href', this.HOST + `/Database/icon/DB_Blank.svg`).attr('x', 7).attr('y', 4).attr('height', 15)
      }

      dropdown
      .on('mouseover', () => { 
        dropdown.attr('cursor', 'pointer')
        d3.select(`#FORM_${props.id}`).attr('fill','#44A9DF')
        d3.select(`#DROP_BOX_${props.id}`).attr('stroke','#44A9DF')
      })
      .on('mouseout', (event) => { 
        dropdown.attr('cursor', 'default')
        d3.select(`#FORM_${props.id}`).attr('fill', '#333')
        d3.select(`#DROP_BOX_${props.id}`).attr('stroke','#757575')

        const [x, y] = d3.pointer(event, dropdown)
        let x1 = this.getNode(`#DROP_BOX_${props.id}`, 'x')+1,
            x2 = x1 + this.getNode(`#DROP_BOX_${props.id}`, 'width')-3,
            y1 = this.getNode(`#DROP_BOX_${props.id}`, 'y')+1
        if(x<x1 || x>x2 || y< y1) d3.select(`#DROP_ITEM_${props.id}`).attr('visibility', 'hidden')
      })
      .on('click', () => { 
        if (d3.select(`#DROP_ITEM_${props.id}`).attr('visibility') == 'hidden') {
          d3.select(`#DROP_ITEM_${props.id}`).attr('visibility', 'visible')
          d3.select(`#ARROW_${props.id}`).attr('transform', `translate(${props.boxWidth - 4}, 14) rotate(180)`)
        } else {
          d3.select(`#DROP_ITEM_${props.id}`).attr('visibility', 'hidden')
          d3.select(`#ARROW_${props.id}`).attr('transform', `translate(${props.boxWidth - 12}, 10) rotate(0)`)
        }
      })

      this.gmx_DropItems(data_, props) //-----> below
    },



    gmx_DropItems(data_, props) {

      d3.select(`#DROP_ITEM_${props.id}`).remove()

      let lineH = 20
      let items = d3.select(`#DROPDOWN_${props.id}`)

      .append('g')
      .attr('id',`DROP_ITEM_${props.id}`)
      .attr('transform', `translate(0, ${28})`).attr('visibility', 'hidden')

      items
      .append('rect')
      .attr('width', props.boxWidth).attr('height', (data_.length * (lineH))+3)
      .attr('fill', '#f9f9f9').attr('stroke','#bcbcbc').attr('stroke-width',0.5)

      data_.forEach((item, i) => {
        items
        .append('rect')
        .attr('id', `ITEM_BOX_${props.id}_${i}`)
        .attr('x', 1).attr('y', (i * lineH)+1)
        .attr('width', props.boxWidth-2).attr('height', lineH).attr('fill', '#fff').attr('opacity', .5)
        
        items
        .append('text')
        .attr('id', `ITEM_TEXT_${props.id}_${i}`)
        .attr('x', props.icon ? 25 : 7).attr('y', (i * lineH) + 10.5 + 12*0.36).attr('fill', '#757575') .attr('font-size', 11)
        .text(item)

        if(props.icon) {
          items
          .append('image')
          .attr('xlink:href', this.HOST + `/Database/icon/DB_${data_[i]}.svg`).attr('x', 7).attr('y', (i * lineH) + 3).attr('height', 15)
        }

        items
        .datum(item)
        .append('rect')
        .attr('id', `optionBtn_${props.id}_${i}`)
        .attr('x', 1).attr('y', i * lineH).attr('width', props.boxWidth-2).attr('height', lineH)
        .attr('fill', 'transparent').attr('stroke','transparent').attr('stroke-width',0.5)
        .attr('cursor', 'pointer')
        .on('mouseover', () => { 
          d3.select(`#ITEM_BOX_${props.id}_${i}`).transition().duration(100).attr('fill','#B4E3FA')
          d3.select(`#ITEM_TEXT_${props.id}_${i}`).attr('fill','#000')
        })
        .on('mouseout', (event) => { 
          d3.select(`#ITEM_BOX_${props.id}_${i}`).transition().duration(100).attr('fill','transparent')
          d3.select(`#ITEM_TEXT_${props.id}_${i}`).attr('fill','#757575')

          const [x, y] = d3.pointer(event, item)
          let x1 = this.getNode(`#DROP_ITEM_${props.id}`, 'x')+1,
              x2 = x1 + this.getNode(`#DROP_ITEM_${props.id}`, 'width')-3,
              y1 = this.getNode(`#DROP_ITEM_${props.id}`, 'y')+1,
              y2 = y1 + this.getNode(`#DROP_ITEM_${props.id}`, 'height')-4
          if(x<x1 || x>x2 || y< y1 || y>=y2) d3.select(`#DROP_ITEM_${props.id}`).attr('visibility', 'hidden')
        })
        .on('click', (d) => { 
          d3.select(`#FORM_${props.id}`).text(item)
          if(props.icon) d3.select(`#ICON_${props.icon}`).attr('xlink:href', this.HOST + `/Database/icon/DB_${data_[i]}.svg`)
          d3.select(`#DROP_ITEM_${props.id}`).attr('visibility', 'hidden')
          d3.select(`#ARROW_${props.id}`).attr('transform', `translate(${props.boxWidth - 12} ,10) rotate(0)`)
          items.attr('visibility', 'hidden')
          
          // Change Type
          let getId = props.id.split('_')[1]
          this.changeType(item, getId)
        })
      })
      
    },

  } 
}